import { makeVar } from "@apollo/client";
import { createContext } from "react";

export type ChatSessionLoadingTextType = {
  chatSessionId: number;
  text: string;
} | null;

export type ChatToolCallType = {
  chatSessionId: number;
  callId: string;
  toolName: string;
  resultCount?: number;
  description?: string;
  status?: "started" | "completed" | "failed";
};

export const chatSessionLoadingTextVar =
  makeVar<ChatSessionLoadingTextType | null>(null);

export const chatToolCallsVar = makeVar<ChatToolCallType[]>([]);

export const ChatSessionContext = createContext<{
  assessmentId?: number;
  assessmentQuestionId?: number;
  meetingId?: number;
  currentSuggestedAssessmentResponseId?: string | null;
  setCurrentSuggestedAssessmentResponseId?: (id: string | null) => void;
}>({
  assessmentId: undefined,
  assessmentQuestionId: undefined,
  meetingId: undefined,
  currentSuggestedAssessmentResponseId: null,
  setCurrentSuggestedAssessmentResponseId: undefined,
});
